export default __webpack_public_path__ + "static/media/cv-ev posters (2).926ac90d.webp";